import useReveal from './useReveal';
import './Timeline.css';

function daysUntil(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return null;
  const days = Math.ceil((date.getTime() - Date.now()) / 86400000);
  return days > 0 ? days : null;
}

function Timeline({ milestones, weddingDate }) {
  const [ref, visible] = useReveal();
  const countdown = daysUntil(weddingDate);

  return (
    <section ref={ref} className={`timeline${visible ? ' is-visible' : ''}`}>
      <header className="timeline-header">
        <p className="section-eyebrow">The Journey</p>
        <h2 className="section-title">Five moments</h2>
      </header>
      <ol className="timeline-list">
        {milestones.map((m, i) => (
          <li
            key={m.date}
            className={`timeline-item timeline-item--${m.color}${
              m.filled ? '' : ' timeline-item--future'
            }`}
            style={{ transitionDelay: `${i * 90}ms` }}
          >
            <span className="timeline-dot" aria-hidden="true" />
            <div className="timeline-body">
              <span className="timeline-date">{m.date}</span>
              <span className="timeline-label">{m.label}</span>
              {!m.filled && countdown !== null && (
                <span className="timeline-countdown">{countdown} days to go</span>
              )}
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}

export default Timeline;
